import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import AppShell from "./shell/AppShell";
import ProjectAlerts from "./ProjectAlerts";
import { useInboxUnreadCount } from "../../hooks/useInboxUnreadCount";
import { PLM_SECTIONS, PLM_ADMIN } from "../../modules/dms/plmNavigation";

// The PLM module's frame. Everything shared with other modules lives in
// AppShell; this only says what PLM's navigation is.
export default function AppLayout() {
  const location = useLocation();
  const unreadCount = useInboxUnreadCount(location.pathname);

  return (
    <AppShell
      storageKey="df.sidebarCollapsed"
      subtitle="Project Lifecycle Management"
      homePath="/dashboard"
      sections={PLM_SECTIONS}
      admin={PLM_ADMIN}
      badges={{ inbox: unreadCount }}
      rightSlot={<ProjectAlerts />}
    >
      {({ subStatus }) => <Outlet context={{ subStatus }} />}
    </AppShell>
  );
}
